(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["locale-switcher"] && !Shopify.designMode) return;
  try {
    class LocaleSwitcherComponent extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[ref="button"]');
      this.panel = this.querySelector('[ref="panel"]');

      if (this.button && this.panel) {
        this.button.addEventListener('click', this.toggle.bind(this));
        document.addEventListener('click', this.handleClickOutside.bind(this));
        document.addEventListener('keyup', this.handleKeyUp.bind(this));
      }
    }

    get isHidden() {
      return this.panel.hasAttribute('hidden');
    }

    toggle() {
      if (this.isHidden) {
        this.show();
      } else {
        this.hide();
      }
    }

    show() {
      const rect = this.button.getBoundingClientRect();
      this.panel.style.left = rect.left + 'px';
      this.panel.style.bottom = (window.innerHeight - rect.top + 8) + 'px';
      this.panel.removeAttribute('hidden');
      this.button.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    hide() {
      this.panel.setAttribute('hidden', '');
      this.button.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    handleClickOutside(event) {
      if (!this.contains(event.target)) {
        this.hide();
      }
    }

    handleKeyUp(event) {
      if (event.key === 'Escape') {
        if (!this.isHidden) {
          this.hide();
          this.button.focus();
        }
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleClickOutside.bind(this));
      document.removeEventListener('keyup', this.handleKeyUp.bind(this));
    }
  }

  if (!customElements.get('locale-switcher-component')) {
    customElements.define('locale-switcher-component', LocaleSwitcherComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
